<template>
    <div class="groupActivity">
        <Header ref="header" :title="title" @backPage="onBack" :color="color" :iconColor='iconColor' :cancleLine='true' />
        <div class="container" :class="{'container2': $iosHeightDiv2() == 'isIosHeight', 'container3': $iosHeightDiv2() == 'isIosHeight2'}" v-show="show">
            <div class="activeImg">
                <img v-show="parseData.image" :src="parseData.image" alt="组合banner">
            </div>
            <div class="tab">
                <van-tabs v-model="active" :swipe-threshold=2 :line-height='0' @click="tabCut">
                    <van-tab v-for="(value, index) in groupActivityData" :key="index">
                        <div slot="title">
                            <div class="tabItem" slot="title">
                                <div class="tabTime" :class="{'tabOpacity': active != index}">{{value.startTime | formatDate4}}</div>
                                <div class="tabStatu" :class="{'tabOpacity': active != index}" v-text="value.displayStatus == 2 ? '即将开场' : '抢购进行中'"></div>
                            </div>
                        </div>
                        <div class="body">
                            <img  @click="handleMatch(value.id)" :src="value.poster" alt="">
                            <div class="btn" @click="handleMatch(value.id)">去搭配</div>
                            <div class="content">
                                <p>订单商品一经售出，无质量原因不予退货；</p>
                                <p>不与其他促销活动同时享受。</p>
                            </div>
                        </div>
                    </van-tab>
                    <div class="tabTips">
                        <div class="toEnd" :class="parseData.displayStatus == 2 ? 'isCome' : 'inProgress'">
                            <div class="lightning">
                                <img :src="parseData.displayStatus == 2 ? src1 : src2" />
                                <div>{{parseData.displayStatus == 2 ? '距离开始' : '距离结束'}}</div>
                            </div>
                            <div class="countDown">
                                <vantCountDown
                                    :underway='parseData.displayStatus == 2'
                                    :time="parseData.countDownTime"
                                    @onCountDown='onCountDown'
                                    v-if="parseData.countDownTime"
                                />
                            </div>
                        </div>
                    </div>
                </van-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import vantCountDown from '../common/vanCountDown'
import Header from '../../common/header'
import { mapMutations } from 'vuex'
import { getGroupAcitivityList } from '../api/activity'
import { clearCache } from '@/utils/index'
import { Toast } from 'vant'
export default {
    name: 'groupActivityList',
    components: {
        Header,
        vantCountDown
    },
    data () {
        return {
            show: false,
            title: '组合go专区',
            color: '#ff4d4f',
            iconColor: 'white',
            userInfo: '',
            groupActivityData: [],
            parseData: {},
            active: 0,
            src1: require('../../../assets/img/b2b/lightningDark.png'),
            src2: require('../../../assets/img/b2b/lightning.png')
        }
    },
    methods: {
        ...mapMutations({
            tabRemember: 'TABREMEMBER'
        }),
        onBack () {
            this.$router.push('/b2b/home/index')
        },
        onCountDown () {
            this.init()
        },
        handleMatch (tyingId) {
            this.tabRemember(this.active)
            this.$router.push({ path: '/b2b/groupActivity/groupActivityCart', query: { tyingId: tyingId } })
        },
        tabCut () {
            this.init()
        },
        async init () {
            const { data } = await getGroupAcitivityList({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode
            })
            if (!data.length) {
                Toast({
                    message: '活动已结束',
                    duration: 1500
                })
                setTimeout(() => {
                    this.$router.push('/b2b/home/index')
                }, 2000)
                return false
            }
            this.groupActivityData = data
            this.parseData = data[this.active]
            this.show = true
        }
    },
    beforeRouteEnter (to, from, next) {
        clearCache('groupActivityCart')
        next()
    },
    async mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.active = this.$store.state.b2b.tabRemember
        this.init()
    }
}
</script>
<style lang="scss" scoped>
// tab切换样式
/deep/ .van-tabs {
    height: 100%;
}
/deep/ .van-tabs__wrap--scrollable .van-tab {
    padding: 0;
}
/deep/ .van-tabs__nav {
    padding: 0 !important;
    background-color: #ff4d4f;
    border-bottom-left-radius: 40px;
    border-bottom-right-radius: 40px;
}
/deep/ .van-tabs__nav .van-tab {
    flex-basis: 50% !important;
    line-height: initial;
}
/deep/ .van-tab__text--ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -webkit-line-clamp: initial;
}
/deep/ .van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
    border: none;
}
/deep/ .van-tabs__content {
    height: calc(100% - 212px);
    overflow: auto;
}
/deep/.van-tabs--line .van-tabs__wrap {
    position: relative;
    height: 212px;
    padding: 0;
}
.groupActivity {
    font-family: PingFangSC;
    height: 100%;
    .container {
        height: calc(100% - 100px);
        position: relative;
        overflow: hidden;
        &.container2{
            height: calc(100% - 145px);
        }
        &.container3{
            height: calc(100% - 192px);
        }
        .activeImg {
            img {
                width: 100%;
                height: 100%;
                border-radius: 16px;
            }
            background: #ff4d4f;
            padding: 0 24px;
            height: 262px;
        }
        .tab {
            height: calc(100% - 262px);
            text-align: center;
            .tabItem {
                height: 204px;
                color: #ffffff;
                img {
                    height: 262px;
                    // position: absolute;
                }
                .tabTime {
                    font-weight: bold;
                    font-size: 32px;
                    padding-top: 16px;
                }
                .tabStatu {
                    font-size: 24px;
                    padding: 0 0 122px 0;
                    transform-origin: center 0%;
                }
                .tabOpacity {
                    font-weight: 400;
                    opacity: 0.5;
                }
            }
        }
        .tabTips {
            position: absolute;
            top: 116px;
            padding: 32px 0;
            width: calc(100% - 48px);
            margin: 0 24px;
            background-color: #fff;
            border-radius: 16px 16px 0 0;
            display: flex;
            justify-content: center;
            align-items: center;
            border-bottom: 2px solid #eeeeee;
            .Tipscontent {
                font-family: PingFangSC;
                color: #000000;
                padding-left: 32px;
                font-size: 28px;
                font-weight: 400;
                display: inline-block;
                height: 32px;
            }
            .toEnd {
                &.isCome {
                    color: #999999;
                }
                &.inProgress {
                    color: #000000;
                }
                display: flex;
                align-items: center;
                padding-right: 32px;
                font-size: 24px;
                font-weight: 400;
                .lightning {
                    display: flex;
                    align-items: center;
                    img {
                        width: 32px;
                        height: 32px;
                    }
                    div {
                        font-size: 24px;
                        height: 32px;
                        line-height: 32px;
                    }
                }
                .countDown {
                    padding-left: 16px;
                    height: 32px;
                }
            }
        }
    }
    .body {
        margin: 0 24px 0 24px;
        background-color: #fff;
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
        padding: 24px;
        img{
            width: 100%;
            height: 260px;
            border-radius: 8px;
        }
        .btn{
            height: 80px;
            line-height: 80px;
            border-radius: 80px;
            background: #ff4d4f;
            color: #ffffff;
            margin-top: 24px;
            margin-bottom: 80px;
            font-size: 28px;
        }
        .content{
            font-size: 24px;
            color: #999999;
            text-align: left;
            p{
                line-height: 36px;
            }
        }
        .hr {
            border-top: 2px solid #eeeeee;
            margin: 0 24px;
        }
    }
}
/deep/ .van-tabs__line{
    height: 0;
    background: none;
}
</style>
